import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { z } from 'zod'
import { usePositionStorage } from '../hooks'
import { AuthLayout, SignUpForm } from '../ui'

const signupSearchSchema = z.object({
	position: z.string().optional(),
	redirect: z.string().optional(),
})

export const Route = createFileRoute('/signup')({
	validateSearch: signupSearchSchema,
	component: RouteComponent,
})

function RouteComponent() {
	const search = Route.useSearch()
	const { savePosition } = usePositionStorage()

	useEffect(() => {
		if (search.position) {
			savePosition(search.position)
		}
	}, [search.position, savePosition])

	return (
		<AuthLayout>
			<SignUpForm />
		</AuthLayout>
	)
}
